const typeOf = (value: unknown): string => {
    return /\s([A-Za-z]+)/.exec({}.toString.call(value))![1].toLowerCase();
};

export default typeOf;
